/**
 * Created by lihanying on 2017/7/6.
 */

export const GETACCOUNTLIST = 'GETACCOUNTLIST'
export const GETCLUBROLELIST = 'GETCLUBROLELIST'
export const GETREGIONLIST = 'GETREGIONLIST'



// WEBPACK FOOTER //
// ./src/containers/ClubUsers/constants.js